import dayJs from 'dayjs'
import { qiniuUploadUrl, qiniuImageURLPrefix, qiniuExportURLPrefix, shopDefault } from '@/config/qiniu'

export { default as debounce } from './debounce'
export { default as throttle } from './throttle'
export { default as type } from './type'
export * from './clone'
export * from './type'

// 判断浏览器
export function isPC() {
    if (/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
        return false
    } else {
        return true
    }
}

export function isWX() {
    var ua = navigator.userAgent.toLowerCase()
    var isWeixin = ua.indexOf('micromessenger') !== -1
    if (isWeixin) {
        return true
    } else {
        return false
    }
}

// 提取url参数

export function getQueryString(href, key) {
    var reg = new RegExp('[?&]' + key + '=([^&]*)', 'g')
    var match = (href || window.location.search).match(reg)
    if (!match) return
    if (match.length === 1) return decodeURIComponent(match[0].replace(reg, '$1'))
    match = match.map(function (item) {
        return decodeURIComponent(item.replace(reg, '$1'))
    })
    return match
}

export function replaceQueryString(paramName, replaceWith) {
    let oUrl = window.location.href.toString()
    let re = new RegExp('(' + paramName + '=)([^&]*)', 'gi')
    let nUrl = oUrl.replace(re, paramName + '=' + replaceWith)
    return nUrl
}

export function removeQueryItem(paramName) {
    let oUrl = window.location.href.toString()
    let re = new RegExp('(' + paramName + '=)([^&]*)', 'gi')
    let nUrl = oUrl.replace(re, '')
    return nUrl
}

export function formatCnTime(time) {
    const target = dayJs(time)
    const now = dayJs()
    const diffValue = now.diff(target)
    if (diffValue < 1000 * 60) { // 小于一分钟
        return '刚刚'
    } else if (diffValue >= 1000 * 60 && diffValue < 1000 * 60 * 60) { // 大于一分钟小于一小时
        return parseInt(diffValue / (1000 * 60)) + '分钟前'
    } else if (target.isBefore(now, 'year')) { // 今年以前
        return dayJs(target).format('YYYY年MM月DD日 HH:mm:ss')
    } else if (target.isBefore(now.subtract(1, 'day'), 'day')) { // 昨天以前 今年以内
        return dayJs(target).format('MM月DD日 HH:mm:ss')
    } else if (target.isBefore(now, 'day')) { // 昨天
        return dayJs(target).format('昨天 HH:mm:ss')
    } else if (diffValue >= 1000 * 60 * 60) { // 大于60分钟
        return dayJs(target).format('HH:mm:ss')
    }
}

export function formatDate(time, format = 'YYYY-MM-DD') {
    return dayJs(time).format(format)
}

export function isIos() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}

export function isAndroid() {
    if (/(Android)/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
}

export function inputLimit(reg) {
    return function (that, key) {
        // debugger
        const fn = Object.prototype.toString.call(that[key]) === "[object Number]" ? Number : String
        let value = that[key].toString()
        do {
            if (!reg.test(value)) {
                if (value.length > 0) {
                    value = value.substr(0, value.length - 1)
                    that[key] = fn(value)
                } else {
                    return
                }
            }
        } while (!reg.test(value))
    }
}
export const inputLimitNormal = inputLimit(/^\S*$/)

export const inputLimitRegExp = /^([1-9][0-9]{0,5}|[0]{1})(\.\d{0,2})?$/

export function unifyData(obj, type) {
    let _obj = JSON.parse(JSON.stringify(obj))
    let data = {
        shopLogo: '',
        shopArea: '',
        shopAddress: '',
        shopDescription: '',
        shopName: '',
        refuseReason: '',
        recommender: '',
        shopId: '',
        shopStatus: '-2'
    }

    if (type === 'ph') {
        for (let key in _obj) {
            if (key === 'station_logo') {
                data.shopLogo = _obj[key]
            } else if (key === 'province') {
                data.shopArea = _obj.province + _obj.city + _obj.district
            } else if (key === 'address') {
                data.shopAddress = _obj[key]
            } else if (key === 'describes') {
                data.shopDescription = _obj[key]
            } else if (key === 'name') {
                data.shopName = _obj[key]
            } else if (key === 'recommender') {
                data.recommender = _obj[key]
            } else if (key === 'id') {
                data.shopId = _obj[key]
            } else if (key === 'refuse_reason') {
                data.refuseReason = _obj[key]
            } else if (key === 'status') {
                if (_obj[key] === -2) {
                    data.shopStatus = '-2'
                } else if (_obj[key] === 0) {
                    data.shopStatus = '0'
                } else if (_obj[key] === -3) {
                    data.shopStatus = '-3'
                }
            } else {
                data[key] = _obj[key]
            }
        }
    } else if (type === 'wsc') {
        for (let key in _obj) {
            if (key === 'shop_img') {
                data.shopLogo = _obj[key]
            } else if (key === 'shop_province') {
                data.shopArea = _obj.shop_province + _obj.shop_city + _obj.shop_county
            } else if (key === 'shop_address') {
                data.shopAddress = _obj[key]
            } else if (key === 'description') {
                data.shopDescription = _obj[key]
            } else if (key === 'recommender') {
                data.recommender = _obj[key]
            } else if (key === 'shop_id') {
                data.shopId = _obj[key]
            } else if (key === 'shop_name') {
                data.shopName = _obj[key]
            } else if (key === 'reject_reason') {
                data.refuseReason = _obj[key]
            } else if (key === 'shop_status') {
                if (_obj[key] === '2') {
                    data.shopStatus = '-2'
                } else if (_obj[key] === '1') {
                    data.shopStatus = '0'
                } else if (_obj[key] === '3') {
                    data.shopStatus = '-3'
                }
            } else {
                data[key] = _obj[key]
            }
        }
    } else if (type === 'new_ls') {
        for (let key in _obj) {
            if (key === 'logo_image_url') {
                data.shopLogo = _obj[key]
            } else if (key === 'shop_county_text') {
                data.shopArea = _obj.shop_county_text + _obj.shop_city_text + (_obj.shop_district_text ? _obj.shop_district_text : '')
            } else if (key === 'detailed_address') {
                data.shopAddress = _obj[key]
            } else if (key === 'recommender_phone') {
                data.recommender = _obj[key]
            } else if (key === 'description') {
                data.shopDescription = _obj[key]
            } else if (key === 'id') {
                data.shopId = _obj[key]
            } else if (key === 'shop_name') {
                data.shopName = _obj[key]
            } else if (key === 'refuse_reason') {
                data.refuseReason = _obj[key]
            } else if (key === 'status') {
                if (_obj[key] === -2) {
                    data.shopStatus = '-2'
                } else if (_obj[key] === 0) {
                    data.shopStatus = '0'
                } else if (_obj[key] === -3) {
                    data.shopStatus = '-3'
                }
            } else {
                data[key] = _obj[key]
            }
        }
    }

    return data
}

/**
 * 把评论中图片数组内的视频去掉并返回修改后图片的新下标
 * @param {Array} arr 
 * @param {integer} preIndex 
 * @return {Object}
 */
export function delVideoInArr(arr, preIndex) {
    let newArr = arr.filter((item, index) => {
        if (item.includes(".mp4") && index < preIndex) preIndex--
        if (item.includes(".jpg")) return item
    })
    return {
        "newArr": newArr,
        "curIndex": preIndex
    }
}
export function getImgFullUrl(value) {
    /* TODO3 */

    if (!value) return shopDefault
    // base64
    if (/^data:/.test(value)) {
        return value
    }
    // 相对路径
    if (/^\//.test(value)) {
        return value
    }
    /* 绝对路径 */
    if (/^http[s]{0,1}:/.test(value)) {
        return value
    }
    return qiniuImageURLPrefix + value
}

export function getOptimizeImgUrl(path, size = 200) {
    const ImgFullUrl = getImgFullUrl(path)
    /* 判断是否为七牛资源 */
    const isQiniuAssets = new RegExp('^' + qiniuImageURLPrefix).test(ImgFullUrl)
    if (isQiniuAssets) {
        const imgSuffix = '?imageView2/2/w/'
        // 如果图片已经经过格式化 就原路径返回
        if (ImgFullUrl.includes(imgSuffix)) {
            return ImgFullUrl
        }
        let suffix = ''
        if (size) {
            suffix = imgSuffix + size
        }
        return ImgFullUrl + suffix
    } else {
        return ImgFullUrl ? ImgFullUrl : shopDefault
    }
}

/**
 * 检查浏览器是否支持CSS
 * @param attribute
 * @param value
 * @return {Boolean}
 */
export const supportsCSS = (attribute, value) => {
    if (window.CSS && window.CSS.supportsCSS) {
        if (typeof value === 'undefined') return window.CSS.supportsCSS(attribute)
        return window.CSS.supportsCSS(attribute, value)
    }

    const elem = document.createElement('div')
    if (attribute in elem.style) {
        elem.style[attribute] = value
        return elem.style[attribute] === value
    }
    return false
}